import JSZip from 'jszip';
import { COMPANY_NAME } from '../config/brandingConfig';

const safeName = (value) => String(value || 'unknown')
  .replace(/[\\/:*?"<>|]+/g, '_')
  .replace(/\s+/g, ' ')
  .trim();

const extractBase64 = (dataUrl) => {
  if (!dataUrl || typeof dataUrl !== 'string') return null;
  const marker = ';base64,';
  const index = dataUrl.indexOf(marker);
  if (index === -1) return null;
  return dataUrl.slice(index + marker.length);
};

export const downloadAttachmentsZip = async ({
  chains,
  entries,
  zipName = 'correspondence_attachments',
}) => {
  const zip = new JSZip();
  const manifestRows = [
    ['Company', COMPANY_NAME],
    ['Generated At', new Date().toISOString()],
    [],
    ['Correspondence Subject', 'Subject ID', 'Entry Ref', 'Direction', 'Letter Date', 'File Name', 'Has Actual File'],
  ];

  chains.forEach((chain) => {
    const chainEntries = entries.filter((entry) => entry.chain_id === chain.id);
    const subjectFolder = `${safeName(chain.subject)}_${chain.id}`;
    chainEntries.forEach((entry) => {
      const directionFolder = safeName(entry.direction || 'Unknown');
      const entryFolder = `${subjectFolder}/${directionFolder}/${safeName(entry.ref_no || `entry_${entry.id}`)}`;
      (entry.attachments || []).forEach((file, index) => {
        const attachmentName = safeName(file.name || `attachment_${index + 1}`);
        const base64 = extractBase64(file.data_url);
        if (base64) {
          zip.file(`${entryFolder}/${attachmentName}`, base64, { base64: true });
        } else {
          const metadata = [
            `File Name: ${file.name || '-'}`,
            `Type: ${file.type || 'application/octet-stream'}`,
            `Size: ${file.size ?? '-'}`,
            `Uploaded At: ${file.uploaded_at || '-'}`,
            '',
            'Actual binary content is not available for this older record.',
          ].join('\n');
          zip.file(`${entryFolder}/${attachmentName}.txt`, metadata);
        }

        manifestRows.push([
          chain.subject || '-',
          chain.id,
          entry.ref_no || '-',
          entry.direction || '-',
          entry.letter_date || '-',
          file.name || '-',
          base64 ? 'Yes' : 'No',
        ]);
      });
    });
  });

  if (manifestRows.length === 1) {
    return false;
  }

  const manifestCsv = manifestRows
    .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  zip.file('manifest.csv', manifestCsv);

  const blob = await zip.generateAsync({ type: 'blob' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${safeName(zipName)}.zip`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  return true;
};
